import { render, staticRenderFns } from "./breedplan.vue?vue&type=template&id=1f46863e&scoped=true&"
import script from "./breedplan.vue?vue&type=script&lang=js&"
export * from "./breedplan.vue?vue&type=script&lang=js&"
import style0 from "./breedplan.vue?vue&type=style&index=0&id=1f46863e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f46863e",
  null
  
)

export default component.exports